import React from 'react';
import PropTypes from 'prop-types';
import SelectProduct from './SelectProduct';

const SelectSilverProduct = ({
  handleBack,
  handleNext,
  defaultValues,
  wizardData,
  setWizardData,
}) => (
  <SelectProduct
    metalType="silver"
    handleBack={handleBack}
    handleNext={handleNext}
    defaultValues={defaultValues}
    wizardData={wizardData}
    setWizardData={setWizardData}
  />
);

SelectSilverProduct.propTypes = {
  handleBack: PropTypes.func,
  handleNext: PropTypes.func,
  defaultValues: PropTypes.shape({}),
  wizardData: PropTypes.shape({}),
  setWizardData: PropTypes.func,
};

export default SelectSilverProduct;
